function updateSectionStatusColor() {
  const statusColorTags = document.querySelectorAll('[data-status-bar-color]')
  let activeTag = null

  statusColorTags.forEach(tag => {
    const boundingRect = tag.getBoundingClientRect()
    const { top, bottom } = boundingRect
    const topUpperThanTop = top <= 0
    const bottomDownToTop = bottom > 0
    const isActive = topUpperThanTop && bottomDownToTop
    if (isActive) activeTag = tag
  })

  // Si aucune section active, on prend la prochaine section à venir
  let fallbackTag = null
  if (!activeTag) {
    let minTop = Infinity
    statusColorTags.forEach(tag => {
      const top = tag.getBoundingClientRect().top
      if (top > 0 && top < minTop) {
        minTop = top
        fallbackTag = tag
      }
    })
  }

  const tagToUse = activeTag || fallbackTag
  if (!tagToUse) return

  const statusColor = tagToUse.getAttribute('data-status-bar-color')
  const statusColorModalVisible = tagToUse.getAttribute(
    'data-status-bar-color-modalvisible',
  )
  const statusBarColorMetaTag = document.querySelector(
    '[name="section-status-bar"]',
  )
  if (!statusBarColorMetaTag) return
  const oldColor = statusBarColorMetaTag.getAttribute('default')
  if (oldColor == statusColor) return
  statusBarColorMetaTag.setAttribute('default', statusColor)
  statusBarColorMetaTag.setAttribute(
    'modalvisible',
    statusColorModalVisible || statusColor,
  )
  document.dispatchEvent(
    new CustomEvent('status_bar_color_changed', {
      detail: {},
    }),
  )
  setThemeColor(statusColor)
}
function setThemeColor(color) {
  const themeColorMetaTag = document.querySelector('[name="theme-color"]')
  themeColorMetaTag.setAttribute('content', color)
  if (themeColorMetaTag.getAttribute('content') !== color) setThemeColor(color)
}

window.addEventListener('scroll', updateSectionStatusColor)
updateSectionStatusColor()
setInterval(() => {
  updateSectionStatusColor()
}, 2000)
